module.exports = __webpack_public_path__ + "img/banner-head-100.f11a962c.jpg";